








































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Mutation, Action } from 'vuex-class'

import { Prop } from 'vue-property-decorator'

// const namespace = 'digitalCurrency'

import {
  NUMBER_OF_MILLISECONDS_IN_A_MINUTE
} from '../../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-3-constants/constants-3-time'

import {
  Notification,
  NOTIFICATION_TYPE_GENERAL
} from '../../../../../service-for-game-evaluation-loop/game-evaluation-loop-type-2-support/support-type-2-random/random-type-2-store/service-for-store-support-vectors/store-support-vectors-type-1-data-structures/data-structures-1-root-state'

import {
  ADD_NOTIFICATION
} from '../../../../../service-for-game-evaluation-loop/game-evaluation-loop-type-2-support/support-type-2-random/random-type-2-store/service-for-store-support-vectors/store-support-vectors-type-2-algorithms/algorithms-type-1-mutations/mutations-1-general'

import moment from 'moment'

const namespace = 'digitalCurrency'

@Component({
  components: {
    //
  }
})
class DigitalCurrencyTransaction7TransactionStartAndStopSubscriptionIntroduction extends Vue {

  @Prop({ default: '' }) transactionId?: string
  @Prop({ default: false }) isStartSubscriptionIntroduction?: boolean
  @Prop({ default: false }) isStopSubscriptionIntroduction?: boolean

  @Mutation(ADD_NOTIFICATION) ADD_NOTIFICATION?: any
  @Action('updateDigitalCurrencyTransaction', { namespace }) updateDigitalCurrencyTransaction?: any

  initialCurrentDate: Date = new Date()

  isStartingTransactionAtCurrentDate: boolean = true
  transactionStartDate: string = ''
  transactionStartDateMenu: boolean = false

  isStartingTransactionAtCurrentTime: boolean = true
  transactionStartTime: string = ''
  transactionStartTimeMenu: boolean = false

  transactionCancellationDate: string = ''
  transactionCancellationDateMenu: boolean = false

  transactionCancellationTimeMenu: boolean = false
  transactionCancellationTime: any = ''

  isValidStartSubscriptionTransactionForm: any = null
  isValidStopSubscriptionTransactionForm: any = null

  errorMessage: string = ''

  isUnlimitedNumberOfRecurrencePayments: boolean = true

  mounted () {
    if (this.$refs['start-subscription-form']) {
      (this.$refs['start-subscription-form'] as any).resetValidation()
    }
    if (this.$refs['stop-subscription-form']) {
      (this.$refs['stop-subscription-form'] as any).resetValidation()
    }
    const currentDate = (new Date())
    this.initialCurrentDate = currentDate
    this.transactionStartDate = moment(currentDate).format('YYYY-MM-DD')
    this.transactionStartTime = moment(currentDate).format('HH:mm')
    this.transactionCancellationDate = moment(currentDate.getTime() + (!this.isStopSubscriptionIntroduction ? NUMBER_OF_MILLISECONDS_IN_A_MINUTE : 0)).format('YYYY-MM-DD')
    this.transactionCancellationTime = moment(currentDate.getTime() + (!this.isStopSubscriptionIntroduction ? NUMBER_OF_MILLISECONDS_IN_A_MINUTE : 0)).format('HH:mm')
  }

  async startSubscription () {

    (this.$refs['start-subscription-form'] as any).validate()

    if (!this.isValidStartSubscriptionTransactionForm) {
      this.errorMessage = 'Invalid Transaction Form'
      return
    } else {
      this.errorMessage = ''
    }

    const scheduledTransactionDate = !this.isStartingTransactionAtCurrentDate ? this.transactionStartDateFormatted : moment(new Date()).format('YYYY-MM-DD')
    const scheduledTransactionTime = !this.isStartingTransactionAtCurrentTime ? this.transactionStartTime : moment(new Date()).format('HH:mm')
    const dateTransactionScheduledForProcessing = (new Date(`${scheduledTransactionDate} ${scheduledTransactionTime}`)).getTime()
    const dateTransactionScheduledForCancellingRecurrence = (new Date(`${this.transactionCancellationDate} ${this.transactionCancellationTime}`)).getTime()

    try {
      await this.updateDigitalCurrencyTransaction({
        digitalCurrencyTransactionId: this.transactionId,
        propertyId: 'dateTransactionReScheduledForProcessing',
        propertyValue: dateTransactionScheduledForProcessing
      })
    } catch (errorMessage: any) {
      this.errorMessage = errorMessage
    }

    try {
      await this.updateDigitalCurrencyTransaction({
        digitalCurrencyTransactionId: this.transactionId,
        propertyId: 'dateTransactionScheduledForCancellingRecurrence',
        propertyValue: !this.isUnlimitedNumberOfRecurrencePayments ? dateTransactionScheduledForCancellingRecurrence : null
      })
    } catch (errorMessage: any) {
      this.errorMessage = errorMessage
    }

    this.emitToggleShowContent({ isVisible: false })

    // Initiate Notification
    this.ADD_NOTIFICATION({
      notificationId: `${Math.random()}`,
      notificationType: NOTIFICATION_TYPE_GENERAL,
      notificationIconImageUrl: 'check_circle',
      notificationMessage: `Transaction Scheduled To Started`,
      notificationDate: new Date()
    } as Notification)
  }

  async stopSubscription () {

    (this.$refs['stop-subscription-form'] as any).validate()

    if (!this.isValidStopSubscriptionTransactionForm) {
      this.errorMessage = 'Invalid Transaction Form'
      return
    } else {
      this.errorMessage = ''
    }

    const dateTransactionScheduledForCancellingRecurrence = (new Date(`${this.transactionCancellationDate} ${this.transactionCancellationTime}`)).getTime()

    try {
      await this.updateDigitalCurrencyTransaction({
        digitalCurrencyTransactionId: this.transactionId,
        propertyId: 'dateTransactionScheduledForCancellingRecurrence',
        propertyValue: dateTransactionScheduledForCancellingRecurrence
      })
    } catch (errorMessage: any) {
      this.errorMessage = errorMessage
    }

    this.emitToggleShowContent({ isVisible: false })

    this.ADD_NOTIFICATION({
      notificationId: `${Math.random()}`,
      notificationType: NOTIFICATION_TYPE_GENERAL,
      notificationIconImageUrl: 'check_circle',
      notificationMessage: `Transaction Scheduled To Stop`,
      notificationDate: new Date()
    } as Notification)
  }

  // Date formating
  get transactionStartDateFormatted () {
    return this.formatDate(this.transactionStartDate)
  }

  // Cancellation Date Formatted
  get transactionCancellationDateFormatted () {
    return this.formatDate(this.transactionCancellationDate)
  }

  formatDate (dateString: string): string {
    if (!dateString) return ''

    const [year, month, day] = dateString.split('-')
    return `${month}/${day}/${year}`
  }

  requireScheduledDateAndTimeToBeGreaterThanCurrentTime () {
    const scheduledTransactionDate = !this.isStartingTransactionAtCurrentDate ? this.transactionStartDateFormatted : moment(this.initialCurrentDate).format('YYYY-MM-DD')
    const scheduledTransactionTime = !this.isStartingTransactionAtCurrentTime ? this.transactionStartTime : moment(this.initialCurrentDate).format('HH:mm')
    const dateTransactionScheduledForProcessing = (new Date(`${scheduledTransactionDate} ${scheduledTransactionTime}`)).getTime()
    return dateTransactionScheduledForProcessing >= this.initialCurrentDate.getTime() - NUMBER_OF_MILLISECONDS_IN_A_MINUTE || 'Scheduled Date should be greater than current time'
  }

  requireScheduledDateAndTimeToBeLessThanCancelledDateAndTime () {
    const scheduledTransactionDate = !this.isStartingTransactionAtCurrentDate ? this.transactionStartDateFormatted : moment(this.initialCurrentDate).format('YYYY-MM-DD')
    const scheduledTransactionTime = !this.isStartingTransactionAtCurrentTime ? this.transactionStartTime : moment(this.initialCurrentDate).format('HH:mm')
    const dateTransactionScheduledForProcessing = (new Date(`${scheduledTransactionDate} ${scheduledTransactionTime}`)).getTime()
    const dateTransactionScheduledForCancellingRecurrence = (new Date(`${this.transactionCancellationDate} ${this.transactionCancellationTime}`)).getTime()

    if (!this.isUnlimitedNumberOfRecurrencePayments) {
      return dateTransactionScheduledForCancellingRecurrence >= dateTransactionScheduledForProcessing || 'Scheduled Date and Time should be less than Cancellation Date and Time'
    }

    return true
  }

  requireCancellationDateAndTimeToBeGreaterThanCurrentDateAndTime () {
    const dateTransactionScheduledForCancellingRecurrence = (new Date(`${this.transactionCancellationDate} ${this.transactionCancellationTime}`)).getTime()
    return dateTransactionScheduledForCancellingRecurrence >= this.initialCurrentDate.getTime() - NUMBER_OF_MILLISECONDS_IN_A_MINUTE || 'Cancellation Date and Time should be greater than Current Date and Time'
  }

  // Emit Toggle show content
  emitToggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.$emit('toggleShowContent', { isVisible })
  }
}

export default DigitalCurrencyTransaction7TransactionStartAndStopSubscriptionIntroduction


